import React, { useState, useEffect, useContext } from "react";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getColocacionMensualComparativoAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const money = (n) => new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" }).format(n);

const ColocacionMensual = ({ selectedSucursal }) => {
  const [mesActual, setMesActual] = useState(0);
  const [mesAnterior, setMesAnterior] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getColocacionMensualComparativoAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setMesActual(result.data.result.mesActual);
      setMesAnterior(result.data.result.mesAnterior);
    })();
  }, [selectedSucursal]);

  const cambio =
    mesAnterior > 0 ? ((mesActual - mesAnterior) / mesAnterior) * 100 : mesActual > 0 ? 100 : 0;
  const deltaTone = cambio > 0 ? "up" : cambio < 0 ? "down" : "flat";
  const delta = `${cambio > 0 ? "↑" : cambio < 0 ? "↓" : ""} ${Math.abs(cambio).toFixed(1)}%`;

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/credits`)}
      icon={<TrendingUpRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="success.light"
      iconColor="success.main"
      value={money(mesActual)}
      label="Colocación del mes"
      delta={delta}
      deltaTone={deltaTone}
    />
  );
};

export default ColocacionMensual;
